export const PDF_SIGNATORY_TYPE_STATIC = "static_signatory";
export const PDF_SIGNATORY_TYPE_ADMIN = "generated_by_admin_signature";

export const PDF_SIGNATORY_TYPE_OPTIONS = [
  {
    internal_name: PDF_SIGNATORY_TYPE_STATIC,
    display_name: "Static signatory",
  },
  {
    internal_name: PDF_SIGNATORY_TYPE_ADMIN,
    display_name: "Generating admin signature",
  },
];

export const is_admin_signature_signatory = (signatory) =>
  String(signatory?.signatory_type || PDF_SIGNATORY_TYPE_STATIC) ===
  PDF_SIGNATORY_TYPE_ADMIN;

export const sections_require_admin_signature = (sections = []) =>
  (Array.isArray(sections) ? sections : []).some(
    (section) =>
      section?.section_type === "sign_off" &&
      (section?.config?.signatories || []).some(is_admin_signature_signatory)
  );

export const normalize_admin_signature_payload = (signature_payload) => ({
  image_data_url: String(signature_payload?.image_data_url || "").trim(),
});
